export default function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js
// module id = 516
// module chunks = 0 1 2 3 4 5 6 7 8